import React from "react";
import "./Presentation.css";
import antonio from "./antonio.png";
import Typed from "typed.js";

const Presentation = () => {
  const el = React.useRef(null);

  React.useEffect(() => {
    const typed = new Typed(el.current, {
      strings: [
        "Développeur PHP et Symfony avec plus de 2 ans d'expérience dans la conception et la maintenance d'applications web modernes. Passionné par le clean code, les bonnes pratiques et la résolution de problèmes techniques."
      ],
      typeSpeed: 40,
      backSpeed: 10,
      backDelay: 3000,
      showCursor: true,
      cursorChar: "▌",
      loop: true
    });

    return () => typed.destroy();
  }, []);

  return (
    <section className="presentation" id="presentation">

      <div className="card">

        <div className="text-zone">
          <h2 className="name">Yves Antonio Rollande</h2>

          <p className="role">Développeur PHP & Symfony</p>

          <p className="typed-text">
            <span ref={el} />
          </p>
        </div>

        <div className="photo-wrapper">
          <span className="glow"></span>
          <img id="img_antonio" src={antonio} alt="Antonio Navira _" />
        </div>

      </div>
    </section>
  );
};

export default Presentation;
